import { IShareCollection } from '../../types/shareCollection';

export const initialShareCollectionValue: Omit<IShareCollection, 'id'> = {
  shareType: 'landing',
  name: '',
  hideNotes: true,
  hideContacts: true,
  hideAddresses: false,
  hideOffersLink: true,
  url: null,
  isFetching: 'idle',
};

export const modifyCollectionWithId = (
  collectionId: number,
  shares: IShareCollection[],
  changes: Partial<IShareCollection> = {},
  defaults: Partial<IShareCollection> = {},
) => {
  const collectionToModifyIndex = shares.findIndex(({ id }) => id === collectionId);

  if (!~collectionToModifyIndex) {
    return [
      ...shares,
      {
        ...initialShareCollectionValue,
        id: collectionId,
        ...defaults,
      },
    ];
  }

  return [
    ...shares.slice(0, collectionToModifyIndex),
    {
      ...defaults,
      ...shares[collectionToModifyIndex],
      ...changes,
    },
    ...shares.slice(collectionToModifyIndex + 1),
  ];
};
